import * as api from '../salesAdminApi';
import { call, put, takeEvery } from 'redux-saga/effects';
import { ISalesDistrict } from '../../lookups';
import { salesAdminActionCreators, SalesAdminActionKeys, SaveSaSalesDistrict } from '..';

function* saveSaSalesDistrictsSaga(action: SaveSaSalesDistrict) {
  //yield put(salesAdminActionCreators.toggleLoading('salesDistrict'));
  const sds: ISalesDistrict[] = yield call(api.SaveSalesDistricts, action.payload);

  yield put(salesAdminActionCreators.setSalesDistricts(sds));

  //yield put(salesAdminActionCreators.toggleLoading('salesDistrict'));
}

export function* watchSaveSaSalesDistricts() {
  yield takeEvery(SalesAdminActionKeys.SAVE_SA_SALES_DISTS, saveSaSalesDistrictsSaga);
}
